function addClassNumber({ dangerousClass }) {
    return ['Class 1: Explosives', 'Class 2: Flammable Gases', 'Class 3: Flammable Liquids', 'Class 4: Flammable Solids', 'Class 5: Oxidizing', 'Class 6: Toxic & Infectious', 'Class 7: Radioactive', 'Class 8: Corrosives', 'Class 9: Miscellaneous'].find(c => c.indexOf(dangerousClass) > -1) || dangerousClass;
}

function getClassNumber({ dangerousClass }) {
    return (['Class 1: Explosives', 'Class 2: Flammable Gases', 'Class 3: Flammable Liquids', 'Class 4: Flammable Solids', 'Class 5: Oxidizing', 'Class 6: Toxic & Infectious', 'Class 7: Radioactive', 'Class 8: Corrosives', 'Class 9: Miscellaneous'].findIndex(c => c.indexOf(dangerousClass) > -1) || 0) + 1;
}

// "Dangerous", with the class and UN code when they were given. Both are optional, so a product
// can be marked dangerous before its details are known.
function dangerousText(product) {
    return 'Dangerous'
        + (product.dangerousClass ? `, class: ${addClassNumber(product)}` : '')
        + (product.dangerousUNCode ? `, code: ${product.dangerousUNCode}` : '');
}

export { addClassNumber, getClassNumber, dangerousText }
